import { render, staticRenderFns } from "./Forbidden.vue?vue&type=template&id=35f46ac9&scoped=true&"
import script from "./Forbidden.vue?vue&type=script&lang=js&"
export * from "./Forbidden.vue?vue&type=script&lang=js&"
import style0 from "./Forbidden.vue?vue&type=style&index=0&id=35f46ac9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f46ac9",
  null
  
)

component.options.__file = "Forbidden.vue"
export default component.exports